const defaults = {
  reportName: '',
  description: '',
  contentType: 'auto',
  content: '={{ $json }}',
  fileName: '',
  overwriteExisting: false,
  allowedUsers: [],
};

export default defaults;
